import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";
// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import "react-toastify/dist/ReactToastify.css";
//redux
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import withRouter from "../../Components/Common/withRouter";
//import images 
import logoLight from "../../assets/images/logo-light.svg";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";
import { userChangePassword } from "../../slices/thunks";
import { setCreatePassword } from "../../slices/auth/forgetpwd/reducer";

/**
 * Component for creating a new password after forgetting the old one.
 *
 * This component allows users to create a new password after forgetting the old one.
 * It uses Formik for form handling and Yup for form validation.
 *
 * @component
 */
const NewPassword = props => {
	const dispatch = useDispatch();
	const location = useLocation();
	const params = new URLSearchParams(location.search);

	// let params = null;
	// if (location.state !== null) {
	// 	params = {reset_token: location.state.token};
	// }

	const validation = useFormik({
		// enableReinitialize : use this flag when initial values needs to be changed
		enableReinitialize: true,

		initialValues: {
			newPassword: "",
			newPassword2: ""
		},
		validationSchema: Yup.object({
			newPassword: Yup.string().required("Please enter your password")
				.min(3, "Password too short"),
			newPassword2: Yup.string()
				.oneOf([Yup.ref("newPassword")], "Passwords do not match")
				.required("Please confirm your password")
				.min(3, "Password too short"),
		}),
		onSubmit: (values) => {
			dispatch(userChangePassword(values, props.router.navigate));
		}
	});

	const selectLayoutProperties = createSelector(
		(state) => state.ForgetPassword,
		(state) => ({
			changePasswordError: state.changePasswordError,
			changePasswordSuccess: state.changePasswordSuccessMsg,
		})
	);

	const {
		changePasswordError, changePasswordSuccess
	} = useSelector(selectLayoutProperties);

	document.title = "Create Password | Adcropper";

	useEffect(() => {
    if (location.search !== '' && location.search !== null && location.search.includes('token')) {
			const token = params.get('token');
			const invitorUser = params.get('invitorUser')
			const isInvite = params.get('isInvite'); 
			const isAdmin = params.get('isAdmin');			
			const faf = params.get('faf');
			dispatch(setCreatePassword({token, invitorUser, isInvite, isAdmin, faf}));
		}
	}, [location]);

	return (
		<React.Fragment>
			<ParticlesAuth>
				<div className="auth-page-content mt-lg-5 mt-xs-5">
					<Container>
						<Row>
							<Col lg={12}>
								<div className="text-center mt-sm-5 mb-4 text-white-50">
									<div>
										<Link to="/" className="d-inline-block auth-logo">
											<img src={logoLight} alt="" height="40" />
										</Link>
									</div>
								</div>
							</Col>
						</Row>

						<Row className="justify-content-center">
							<Col md={8} lg={6} xl={5}>
								<Card className="mt-4">

									<CardBody className="p-4">
										<div className="text-center mt-2">
											<h5 className="text-primary">Create new password</h5>
											<p className="fs-12 text-muted">Your new password must be different from your past passwords.</p>
										</div>

										{changePasswordError ?
											<Alert className="border-0 fs-12 mb-2 mx-2" color="danger">
												{changePasswordError}
											</Alert> :
											changePasswordSuccess ?
												<Alert className="border-0 fs-12 mb-2 mx-2" color="success">
													{changePasswordSuccess}
												</Alert> :
												null
										}

										<div className="p-2 mt-4">
											<Form
												onSubmit={(e) => {
													e.preventDefault();
													validation.handleSubmit();
													return false;
												}}
												className="needs-validation" action="#">

												<div className="mb-3">
													<Label htmlFor="password" className="form-label">Password</Label>
													<Input
														name="newPassword"
														type="password"
														placeholder="Enter Password"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														value={validation.values.newPassword || ""}
														invalid={
															validation.touched.newPassword && validation.errors.newPassword ? true : false
														}
													/>
													{validation.touched.newPassword && validation.errors.newPassword ? (
														<FormFeedback type="invalid"><div>{validation.errors.newPassword}</div></FormFeedback>
													) :
														<div className="mt-1">
															<p className="fs-11 text-muted">Must be at least 8 characters.</p>
														</div>
													}
												</div>

												<div className="mb-4">
													<Label htmlFor="newPassword2" className="form-label">Confirm Password</Label>
													<Input
														name="newPassword2"
														type="password"
														placeholder="Confirm Password"
														onChange={validation.handleChange}
														onBlur={validation.handleBlur}
														value={validation.values.newPassword2 || ""}
														invalid={
															validation.touched.newPassword2 && validation.errors.newPassword2 ? true : false
														}
													/>
													{validation.touched.newPassword2 && validation.errors.newPassword2 ? (
														<FormFeedback type="invalid"><div>{validation.errors.newPassword2}</div></FormFeedback>
													) : null}

												</div>

												<div className="form-check">
													<Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
													<Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
												</div>

												<div className="mt-4">
													<button className="btn btn-success w-100" type="submit">Create password</button>
												</div>

											</Form>
										</div>
									</CardBody>
								</Card>
								<div className="mt-4 text-center">
									<p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold link-danger text-decoration-underline"> Click here </Link> </p>
								</div>
							</Col>
						</Row>
					</Container>
				</div>
			</ParticlesAuth>
		</React.Fragment>
	);
};

NewPassword.propTypes = {
	history: PropTypes.object,
};

export default withRouter(NewPassword);